export enum EntityName {
  inspections = 'inspections',
  sites = 'sites',
  levels = 'levels',
  companies = 'companies',
  contracts = 'contracts',
  inspectionTemplates = 'inspection templates',
  worktypes = 'field values',
  users = 'users',
  visibleFields = 'visible fields',
  directories = 'directories',
  documentations = 'documentations',
  organizations = 'organizations',
  projects = 'projects',
  processes = 'processes',
  issueWorkflows = 'issue workflows',
  issues = 'issues',
  issueForm = 'issueForm',
  inspection = 'inspection',
  inspectionTemplate = 'inspectionTemplate',
  documentation = 'documentation',
  directory = 'directories',
  visibleField = 'visibleFields',
}
